/**
 * Returns this value if client or candidate stated did not happen
 */
export const DID_NOT_HAPPEN_DELTA_CODE = 9999
